import { CMDBaseInformation } from "./CMDBaseInformation"
import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScInitNewBlackjack implements ICommand
{

	public Multipier : number = 0;
	public Information : CMDBaseInformation;
	public OldResult : Array<string>;
	public JSON : string = "";

	public constructor()
	{
		this.OldResult = new Array<string>();
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Multipier = ba.readUint32();
		this.Information = new CMDBaseInformation();
		this.Information.fromBytes(ba);
		let OldResultSize:number = ba.readUint8();
		while (OldResultSize-- > 0)
		{
			let OldResultChild:string = ba.readString();
			this.OldResult.push(OldResultChild);
		}
		this.JSON = ba.readString();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint32(this.Multipier);
		let tempBuf1 = this.Information.toBytes().toBuffer();
		ba.appendBuf(tempBuf1)
		ba.writeUint8(this.OldResult.length);
		for (const OldResultChild of this.OldResult)
		{
			ba.writeString(OldResultChild);
		}
		ba.writeString(this.JSON);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScInitNewBlackjack();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Multipier(D)='+this.Multipier+' ';
		str += 'Information(CMDBaseInformation)='+this.Information+' ';
		str += 'OldResult_size(B)='+this.OldResult.length + ' ';
		str += 'OldResult(S)=[';
		for (let OldResultChild in this.OldResult)
		{
			if (<number><unknown>OldResultChild > 0) str += ', ';
			str += this.OldResult[OldResultChild];
		}
		str += '] ';
		str += 'JSON(S)='+this.JSON+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30517;
	}

	public getCmdName() : string
	{
		return 'ScInitNewBlackjack';
	}

}
